import { Compass01Icon } from "@hugeicons/core-free-icons";
import { useState, MouseEvent } from "react";
import { Link } from "react-router-dom";
import { Badge, BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { HugeiconsIcon } from "@hugeicons/react";
import SummaryBox from "@/features/order/Order";
import { Section } from "@/features/dine-in-flow/Canvas";
import { useResponsive, useMenuNavigation } from "@/hooks";
import OrderDrawer from "@/features/order/components/OrderDrawer";

interface Props {
  sections?: Section[];
}

const MenuBottomNavigation = ({ sections = [] }: Props) => {
  const { isMobile } = useResponsive();
  const {
    activeMenuItem,
    setActiveMenuItem,
    openOrder,
    setOpenOrder,
    menuItems,
  } = useMenuNavigation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenIndex = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseIndex = () => {
    setAnchorEl(null);
  };

  const scroll = (target: string) => {
    const element = document.getElementById(`section-${target}`);
    if (element) {
      window.scrollTo({
        top: element.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
        height: "70px",
        zIndex: 100,
        overflowX: "auto",
        overflowY: "hidden",
        scrollbarWidth: "thin",
        WebkitOverflowScrolling: "touch",
        scrollbarColor: "rgba(255, 255, 255, 1)",
        "&::-webkit-scrollbar": {
          height: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: "4px",
        },
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={activeMenuItem}
        onChange={(_event, newValue) => {
          if (newValue < menuItems.length) {
            setActiveMenuItem(newValue);
          }
        }}
        sx={{
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          height: "100%",
          display: "flex",
          width: "max-content",
          minWidth: "100%",
          alignItems: "center",

          "& .MuiBottomNavigationAction-root": {
            flex: "0 0 auto",
            minWidth: "80px",
            maxWidth: "none",
          },
        }}
      >
        {menuItems.map((item) => {
          const actionProps: any = {};
          if (item.to) {
            actionProps.component = Link;
            actionProps.to = item.to;
          } else if (item.onClick) {
            actionProps.onClick = item.onClick;
          }

          const iconElement =
            item.type === "hugeicons" ? (
              <HugeiconsIcon icon={item.icon} size={24} />
            ) : (
              <item.icon />
            );

          return (
            <BottomNavigationAction
              key={item.id}
              label={item.label}
              icon={
                item.badge ? (
                  <Badge variant="dot" color="primary">
                    {iconElement}
                  </Badge>
                ) : (
                  iconElement
                )
              }
              {...actionProps}
              sx={{
                "& .MuiBottomNavigationAction-label": {
                  fontSize: item.id === "cuenta" ? "0.85rem" : "0.75rem",
                },
              }}
            />
          );
        })}

        {sections?.length ? (
          <BottomNavigationAction
            label="Indice"
            icon={<HugeiconsIcon icon={Compass01Icon} />}
            onClick={handleOpenIndex}
            sx={{
              "& .MuiBottomNavigationAction-label": {
                fontSize: "0.85rem",
              },
            }}
          />
        ) : null}
      </BottomNavigation>
      <OrderDrawer isOpen={openOrder} onClose={() => setOpenOrder(false)} anchor={isMobile ? "top" : "right"}>
        <SummaryBox onClose={() => setOpenOrder(false)} />
      </OrderDrawer>
      {/* Index */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseIndex}>
        {sections.map((section) => (
          <MenuItem
            key={section.slug}
            onClick={() => {
              scroll(section.slug);
              handleCloseIndex();
            }}
          >
            {section.label}
          </MenuItem>
        ))}
      </Menu>
    </Paper>
  );
};

export default MenuBottomNavigation;
